import z from "zod";

import { electedRepresentativeTypeSchema } from "./elected-representative-type";
import { userSchema } from "./user";

export const associationMemberSchema = userSchema.extend({
  active: z.boolean(),
  isOwner: z.boolean(),
  electedRepresentativeType: electedRepresentativeTypeSchema.nullish(),
});

export type AssociationMember = z.infer<typeof associationMemberSchema>;
